import PropTypes from "prop-types"

import LinkButton from "../LinkButton/LinkButton"
import Button from "../buttons/Button"

// si existe
import styles from "./VideoWithText.module.scss"

const VideoWithText = ({
  videoSrc,
  videoAlt,
  title,
  buttonType = "button", // "button" o "link"
  buttonLabel,
  buttonLink = "#",
}) => {
  return (
    <div className={styles.container}>
      <video
        className={styles.video}
        src={videoSrc}
        autoPlay
        muted
        loop
        playsInline
        aria-label={videoAlt}
      />
      <div className={styles.textOverlay}>
        <h1>{title}</h1>
        <div>
          {buttonType === "link" ? (
            <LinkButton to={buttonLink} primary>
              {buttonLabel}
            </LinkButton>
          ) : (
            <Button primary size="large" type="button">
              {buttonLabel}
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}

VideoWithText.propTypes = {
  videoSrc: PropTypes.string.isRequired,
  videoAlt: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  buttonType: PropTypes.oneOf(["button", "link"]),
  buttonLabel: PropTypes.string.isRequired,
  buttonLink: PropTypes.string,
}

VideoWithText.defaultProps = {
  buttonType: "button",
  buttonLink: "#",
}

export default VideoWithText
